
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Routes } from "react-router-dom";
import {
  Table,
} from "reactstrap";
import { fetchBillingualRequests } from "slices/appointmentSlice";

import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { SortButtons } from "components/common/SortButtons";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/appointmentSlice";
import { removeMultipleAppointments } from "slices/appointmentSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { PAGELENGTH } from "components/common/ListLayout";
import { appointmentsSelector } from "slices/appointmentSlice";
import { setSuccessMessage } from "slices/appSlice";
import SuccessMessageModal from "components/SuccessMessageModal";
import { fetchLanguages } from "slices/languageSlice";
import { languageSelector } from "slices/languageSlice";
import { setAddAppointmentPopup, downloadBillingualReport } from "slices/appointmentSlice";
import { selectCustomStyles } from 'components/common/Select';
import AppointmentView from "./appointment/view";
import InviteInterpreter from "./appointment/view/InviteInterpreter";
import { usePermissions } from "layouts/Admin";
import { getBackgroundStyle } from "components/common/TableColor";
import moment from "moment";
import { useForm, Controller } from "react-hook-form";
import { AsyncPaginate } from "react-select-async-paginate";
import DatePicker from "react-datepicker";
import { fetchInterpreterOptions } from "slices/interpreterSlice";
import { fetchSchools } from "slices/schoolSlice";
import { schoolSelector } from "slices/schoolSlice";
import "react-datepicker/dist/react-datepicker.css";
import { LegendButton } from "components/common/TableColor";
import { legends } from "components/common/TableColor";
import DateRangeFilter from "components/common/DateRangeFilter";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";

const apiService = new Api();

const billingualRoutes = [
  {
    path: "",
    component: <BillingualRequests />,
  },
  {
    path: "view/:id",
    component: <AppointmentView />,
  },
  {
    path: "invite-interpreter/:id",
    component: <InviteInterpreter />,
  },
]


export const BillingualRoutes = () => {

  return (
    <Routes>
      {billingualRoutes.map(({ path, component }) => (
        <Route key={path} path={path} element={component} />
      ))}
    </Routes>
  )

}

function BillingualRequests() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions()
  const location = useLocation();

  const { appointments, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(appointmentsSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const interpreters = useSelector((state) => state.interpreter.interpreter);
  const [freelancerFilter, setFreelancerFilter] = React.useState(null);
  const [activeLegends, setActiveLegends] = useState([0]);
    const [statusValues, setStatusValues] = useState([]);
  const [filters, setFilters] = React.useState({});
  const [downloading, setDownloading] = useState(false);
  const { language: languages } = useSelector(languageSelector);
  const [activeLegend, setActiveLegend] = React.useState(0);
  const { school: schools } = useSelector(schoolSelector);
  const { control, handleSubmit, reset, setValue, getValues } = useForm({
    defaultValues: {
      start_date: null,
      end_date: null,
      appointment_id: "",
      interpreter: null,
      freelancer: null,
      status: "",
    },
  });
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  // React.useEffect(() => {
  //   dispatch(fetchBillingualRequests())
  // }, []);
  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");
    const startFromTomorrow = moment().add(1, "day").format("YYYY-MM-DD");
    const fourteenDaysAfter = moment().add(14, "days").format("YYYY-MM-DD");

    if (location.state?.filterByToday) {
      const params = {
        page: 1,
        start_date: today,
        end_date: today,
        exclude_declined: true,
      };

      setValue("start_date", new Date());
      setValue("end_date", new Date());

      dispatch(fetchBillingualRequests(1, params));
    } else if (location.state?.filterByFourteen) {
      const params = {
        page: 1,
        start_date: startFromTomorrow,
        end_date: fourteenDaysAfter,
        exclude_declined: true,
      };

      setValue("start_date", moment().add(1, "day").toDate());
      setValue("end_date", moment().add(14, "days").toDate());

      dispatch(fetchBillingualRequests(1, params));
    } else {
      dispatch(fetchBillingualRequests())
    }
  }, [location.state]);

  const handleAddAppointmentPopUp = (item) => {
    dispatch(setAddAppointmentPopup({
      show: true,
      item,
    }))
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchBillingualRequests())
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleAppointments({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(appointments && appointments?.map((appointment) => appointment.id.toString()))


  }


  const handleActiveLegend = (id, value) => {
    if (value === "all") {
      // When clicking 'All'
      setActiveLegends([id]);
      setStatusValues([]);
      const filters = {
        ...getValues(),
        status: undefined,
      };
      dispatch(fetchBillingualRequests(1, filters));
    } else {
      setActiveLegends((prev) => {
        // Remove 'All'
        const withoutAll = prev.filter((pid) => pid !== 0);

        let newActiveLegends, newStatuses;

        if (withoutAll.includes(id)) {
          // If already selected, remove it
          newActiveLegends = withoutAll.filter((pid) => pid !== id);
          newStatuses = statusValues.filter((s) => s !== value);
        } else {
          // Add new status
          newActiveLegends = [...withoutAll, id];
          newStatuses = [...statusValues, value];
        }

        // If no statuses left, default to 'All'
        if (newActiveLegends.length === 0) {
          newActiveLegends = [0];
          newStatuses = [];
        }

        setStatusValues(newStatuses);

        const filters = {
          ...getValues(),
          status: newStatuses.length ? newStatuses : undefined,
        };
        dispatch(fetchBillingualRequests(1, filters));
        setFilters(filters)
        return newActiveLegends;
      });
    }
  };


  const filteredSchools = React.useMemo(() =>
    schools?.map(language => {
      const object = {
        value: language?.id,
        label: language?.name
      }
      return object
    }), [schools]);

  const filteredSchoolLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchSchools(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true))
    return {
      options: result.data.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      hasMore: page !== result?.last_page ? true : false,
      additional: {
        page: page + 1,
      },
    };
  };


  const [languageState, setLanguageState] = useState({
    label: "",
    value: ""
  })

  useEffect(() => {
    setLanguageState(
      languages?.map(val => ({
        label: val?.language?.name || "",
        value: val?.language?.id || ""
      }))
    );
  }, [languages]);


  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result?.data?.map(language => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };


  const handleReset = () => {

    setActiveLegends([0]);
    setStatusValues([]);
    setLanguageState([]);
    setFreelancerFilter(null);
    reset({
      start_date: null,
      end_date: null,
      appointment_id: "",
      interpreter: null,
      freelancer: null,
      status: "",
    });

    setFilters({});

    dispatch(fetchBillingualRequests(1, {}));
  };

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    const values = getValues();
    const params = {
      start_date: values.start_date
        ? moment(values.start_date).format("YYYY-MM-DD")
        : null,
      end_date: values.end_date
        ? moment(values.end_date).format("YYYY-MM-DD")
        : null,
      appointment_id: values.appointment_id || "",
      interpreter: values.interpreter || values.freelancer || "",
      status: statusValues || "",
    };
    dispatch(fetchBillingualRequests(page, params));
  }, [])

  const handleClose = () => {
    // refAddutton.current.click(); 
    setAddForm({ show: false });

  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }



  const downloadBlobFile = (blob, filename = "appointments.xlsx") => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadReport = () => {
    setDownloading(true); // agar tum loader state use kar rahe ho


    const filters = {
      ...getValues(),
      status: statusValues
    };

    dispatch(
      downloadBillingualReport(filters, (success, res) => {
        setDownloading(false);

        if (!success) {
          Swal.fire({
            title: "Error!",
            text: (res && res.message) || "Failed to download report",
            icon: "error",
            confirmButtonColor: "#d33",
          });
          return;
        }

        try {
          // ✅ Blob file handling
          if (res instanceof Blob) {
            downloadBlobFile(res);
          } else if (res && res.blob) {
            downloadBlobFile(res.blob, res.filename || "dashboard_report.xlsx");
          } else if (typeof res === "string" && res.startsWith("data:")) {
            const arr = res.split(",");
            const mimeMatch = arr[0].match(/:(.*?);/);
            const mime = mimeMatch ? mimeMatch[1] : "application/octet-stream";
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8 = new Uint8Array(n);
            while (n--) u8[n] = bstr.charCodeAt(n);
            const blob = new Blob([u8], { type: mime });
            downloadBlobFile(blob);
          } else if (typeof res === "string") {
            const a = document.createElement("a");
            a.href = res;
            a.target = "_blank";
            a.download = "";
            document.body.appendChild(a);
            a.click();
            a.remove();
          }

          Swal.fire({
            title: "Success!",
            text: "Report downloaded successfully.",
            icon: "success",
            confirmButtonColor: "#3085d6",
          });
        } catch (err) {
          console.error("Download error:", err);
          Swal.fire({
            title: "Error!",
            text: "Could not process downloaded file",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      })
    );
  };



  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchBillingualRequests(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th>
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Appointments') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>


        <th >

          <TableHeaderItem
            title="appid"
            sortBy="appid"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Language"
            sortBy="language"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Requester Name"
            sortBy="contact_person_name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="School"
            sortBy="school"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {/* <th className="col-2">
          <TableHeaderItem
            title="Type"
            sortBy="type"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th> */}

        <th className="col-2">
          <TableHeaderItem
            title="Interpreter"
            sortBy="interpreter"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {/* <th className="col-2">
          <TableHeaderItem
            title="Meeting Date & time"
            sortBy="meeting_date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-2">
          <TableHeaderItem
            title="School"
            sortBy="school"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th> */}

        <th className="col-2">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {/* <th className="col-2">
                  <TableHeaderItem
                    title="Status"
                    sortBy="status"
                    sortDirection={sortConfig.sortDirection}
                    callBack={callBack}
                  />
                </th> */}
        {/* {checkPermission('Edit Appointments') &&
          <th className="col-1">Actions</th>
        } */}
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, appointments]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      appointments && appointments?.map((appointment, index) => (
        <AppointmentItem appointment={appointment} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddAppointmentPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [appointments, selectedItems, current_page]);


  const filteredStatuses = React.useMemo(() => {
    const temp_array = [...legends];
    temp_array.unshift({
      value: "all",
      name: "All",
      id: 0,
      color: "#3176A0"
    })
    return temp_array;
  }, [legends]);


  useEffect(() => {
    (async () => {
      const result = await dispatch(fetchInterpreterOptions());
      console.log("Prefetched interpreters:", result);
    })();
  }, [dispatch]);


  const interpreterOptions = React.useMemo(
    () =>
      interpreters?.map((i) => ({
        value: i.id,
        label: i.user.name || i.name || "Unknown",
      })) || [],
    [interpreters]
  );

  const interpreterLoadOptions = async (inputValue, loadedOptions, { page }) => {
    return await dispatch(
      fetchInterpreterOptions(page, {
        pageLength: 10,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
        employment_type: "permanent",
      })
    );
  };

  const freelancerLoadOptions = async (inputValue, loadedOptions, { page }) => {
    return await dispatch(
      fetchInterpreterOptions(page, {
        pageLength: 10,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
        employment_type: "freelancer",
      })
    );
  };

  //#endregion

  return (
    <>
      <div style={{ margin: '84px 16px 0' }}>
        <div class="row_main_head"><h2 class="main_heading">Bilingual Requests</h2></div>
        <div className="card_table">
          <div className="button-sm forLegends p-3 gap-1">
            <LegendButton
              activeIds={activeLegends}
              options={filteredStatuses}
              handleClick={handleActiveLegend}
            />
          </div>
          <form
            onSubmit={handleSubmit((values) => {
              const params = {
                start_date: values.start_date
                  ? moment(values.start_date).format("YYYY-MM-DD")
                  : null,
                end_date: values.end_date
                  ? moment(values.end_date).format("YYYY-MM-DD")
                  : null,
                appointment_id: values.appointment_id || "",
                school_id: values.school_id ?? null,
                // both filters narrow to a single interpreter id; they are two
                // dropdowns purely to keep permanent staff and freelancers apart
                interpreter: values.interpreter || values.freelancer || "",
                language_ids: values.language_ids || [],
                status: statusValues || "",
              };
              setFilters(params);
              dispatch(fetchBillingualRequests(1, params));
            })}
            className="search_form_ad"
          >
            {/* Start Date */}
            <div className="row-primary dahboard_filter appointments">
              <DateRangeFilter control={control} />

              {/* Appointment ID */}
              <div className="row-primary">
                <h2>Appointment ID</h2>
                <Controller
                  name="appointment_id"
                  control={control}
                  render={({ field }) =>
                    <div className="input-basis basic_bases">
                      <input
                        {...field}
                        type="text"
                        className="input-in type_inp"
                        placeholder="Enter ID"
                      />
                    </div>
                  }
                />
              </div>

              {/* Interpreter */}
              <div className="row-primary" style={{ flexBasis: '40%' }}>
                <h2>
                  Interpreter
                </h2>
                <div style={{ flex: 1 }}>
                  <Controller
                    name="interpreter"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <div className="basic_bases">
                        <AsyncPaginate
                          menuPlacement="auto"
                          styles={{ ...selectCustomStyles }}
                          value={
                            field.value
                              ? interpreterOptions.find((opt) => String(opt.value) === String(field.value))
                              : null
                          }
                          loadOptions={interpreterLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(obj) => field.onChange(obj?.value ?? null)}
                          additional={{ page: 1 }}
                        />
                      </div>
                    )}
                  />
                </div>
              </div>

              {/* Freelancer */}
              <div className="row-primary" style={{ flexBasis: '40%' }}>
                <h2>
                  Freelancer
                </h2>
                <div style={{ flex: 1 }}>
                  <Controller
                    name="freelancer"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <div className="basic_bases">
                        <AsyncPaginate
                          menuPlacement="auto"
                          styles={{ ...selectCustomStyles }}
                          value={freelancerFilter}
                          loadOptions={freelancerLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(obj) => {
                            setFreelancerFilter(obj || null);
                            field.onChange(obj?.value ?? null);
                          }}
                          additional={{ page: 1 }}
                        />
                      </div>
                    )}
                  />
                </div>
              </div>

              <div className="row-primary">
                <h2>School</h2>
                <Controller
                  name="school_id"
                  control={control}
                  render={({ field }) =>
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement='auto'
                        styles={{
                          ...selectCustomStyles,
                        }}
                        value={field.value ? filteredSchools?.find((opt) => field.value == opt.value) : ""}
                        loadOptions={filteredSchoolLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          field.onChange(obj?.value);
                        }}
                        additional={{
                          page: 1,
                        }}
                      />
                    </div>
                  }
                />
              </div>
              <div className="row-primary">
                <h2>Languages</h2>
                <Controller
                  name="language_ids"
                  control={control}
                  render={({ field }) =>
                    <div style={{ width: "100%" }}>
                      <div style={{ width: "100%" }} className="multiselect">
                        <AsyncPaginate
                          menuPlacement='auto'
                          isMulti
                          styles={{
                            ...selectCustomStyles,
                          }}
                          value={languageState}
                          loadOptions={filteredLanguagesLoadOptions}
                          isClearable
                          escapeClearsValue
                          onChange={(selected) => {
                            setLanguageState(selected)
                            field.onChange(selected.map((opt) => opt.value))
                          }}
                          additional={{
                            page: 1,
                          }}
                        />
                      </div>
                    </div>
                  }
                />
              </div>
            </div>


            {/* Buttons */}
            <div className="d-flex align-items-center justify-content-between px-3">
              <div className="row-primary row_10 w-100">
                <button type="submit" className="main_button  green">
                  Search
                </button>
                {/* <SubmitButton handleSubmit={handleSubmit(onSubmit)} buttonType="button" btnText="Search" className={'green'} /> */}
                <button
                  type="button"
                  className="main_button  lightBlue"
                  onClick={handleReset}
                >
                  Reset
                </button>
                <button
                  type="button"
                  style={{ height: "fit-content", marginLeft: "auto" }}
                  className="main_button"
                  onClick={handleDownloadReport}
                >
                  Export to Excel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ListLayout
        // heading="Bilingual Requests"
        key={JSON.stringify(filters)}
        time={true}
        className={"mt-2 ms-2 me-2"}
        title=""
        buttonTitle="Add Appointment"
        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        addButtonDisabled={!checkPermission('Add Appointments')}
        totalPages={totalPages}
        fetchList={fetchBillingualRequests}
        filtration={filters}
        selectedItems={selectedItems}
        handleRemoveItems={handleRemoveItems}
        // renderAddForm={(callback) => <AddAppointment item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} />}
        refAddutton={refAddutton}
        addForm={addForm}
        showConfirmDialog={showConfirmDialog}
        handleAddPopUp={handleAddAppointmentPopUp}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        loader={loader}
        searchPlaceholder="Search Bilingual Requests ..."
        noOfItems={total}
        refAddPopUp="#addAppointmentPopUp"
        disableBootstrap={true}
        addformModal={false}
        styling='appointment'
      >
        <SuccessMessageModal />

        {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
      </ListLayout>
    </>
  )

}


const AppointmentItem = ({
  appointment, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(appointment?.status == "active" ? 1 : 0 || 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  useEffect(() => {
    setStatus(
      appointment?.status
    )

  }, [appointment]);

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);


  const statuses = [
    {
      label: "Available",
      value: "available",
    },
    {
      label: "Assigned",
      value: "assigned",
    }, {
      label: "DNC",
      value: "dnc",
    },
    {
      label: "CNC",
      value: "cnc",
    },
    {
      label: "Completed",
      value: "completed",
    },
    {
      label: "Cancelled",
      value: "cancelled",
    }
  ]

  const rawDatetime = appointment?.date + " " + appointment?.start_time;

  const formattedDate = moment(rawDatetime, 'YYYY-MM-DD HH:mm:ss').format('MMM D, YYYY HH:mm:ss');

  const typeLabels = {
    0: "Interpreting Request",
    1: "After Hours Request",
    2: "Bilingual Exams Request",
  };
  console.log("appointment", appointment);
  return (
    <tr>
      <td style={getBackgroundStyle(appointment?.status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Appointments') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={appointment.id} checked={selectedItems.includes(appointment.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {checkPermission('Detail Appointments') ?
          <Link className='link_preview' to={`/billingual-requests/view/${appointment?.id}`}>
            {appointment?.appid}
          </Link>
          :
          appointment?.appid
        }
      </td>


      <td
        style={{
          ...getBackgroundStyle(appointment?.status),
          lineHeight: "1.5",
        }}
      >
        {appointment?.language?.name || 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.status}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.appointment_details?.contact_person_name}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.school?.name || 'N/A'}
      </td>
      {/* <td style={getBackgroundStyle(appointment?.status)}>
        {typeLabels[appointment?.type] || ""}
      </td> */}

      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.interpreter?.user?.name || 'N/A'}
      </td>
      {/* <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.date ? formattedDate : 'N/A'}
      </td>
      <td style={getBackgroundStyle(appointment?.status)}>
        {appointment?.school?.name || 'N/A'}
      </td> */}

      <td style={getBackgroundStyle(appointment?.status)}>
        {moment((appointment.created_at), 'YYYY-MM-DD HH:mm').format('MMM D, YYYY HH:mm')}
      </td>


      {/* <td className="text-capitalize" style={getBackgroundStyle()}>
              {}
            </td> */}
      {/* <td  style={getBackgroundStyle()}className="text-capitalize">
        {}
      </td> */}
      {/* {checkPermission('Edit Appointments') &&
        <td style={getBackgroundStyle()}>
          <div className="row_check">
            <button className="table_edit" onClick={() =>
              handleAddPopUp({ ...appointment, status })}>Edit</button>
          </div>
        </td>
      } */}
    </tr>
  )
}


export default BillingualRequests;
